/* unplugin-vue-components disabled */import { render } from "./OssUploader.vue?vue&type=template&id=772c2b10&scoped=true"
import script from "./OssUploader.vue?vue&type=script&lang=js"
export * from "./OssUploader.vue?vue&type=script&lang=js"

import "./OssUploader.vue?vue&type=style&index=0&id=772c2b10&lang=scss&scoped=true"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-772c2b10"]])

export default __exports__